import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import classnames from "classnames";
import { Box } from "../../Box/index.js";
import { FormatHeadingPlugin, FormatTextPlugin, LinkAndTablePlugin, ListAndFormatPlugin, MediaPlugin, SelectAllPlugin, TableActionMenuPlugin, UndoRedoPlugin } from "./plugins/index.js";
import { Divider } from "./ui/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const ToolbarPlugins = (t0)=>{
    const $ = c(38);
    const { config, editable, loadFile, onUploadError, bgcolor, classes, floatingAnchorElem, stickyToolbar } = t0;
    const t1 = !editable;
    let t2;
    if ($[0] !== classes.toolbarDisabled || $[1] !== classes.toolbarSticky || $[2] !== stickyToolbar || $[3] !== t1) {
        t2 = classnames({
            [classes.toolbarSticky]: stickyToolbar,
            [classes.toolbarDisabled]: t1
        });
        $[0] = classes.toolbarDisabled;
        $[1] = classes.toolbarSticky;
        $[2] = stickyToolbar;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== config.plugins.selectAllPlugin.value || $[6] !== config.plugins.selectAllPlugin.withDivider) {
        t3 = config.plugins.selectAllPlugin.value && /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx(SelectAllPlugin, {}),
                config.plugins.selectAllPlugin.withDivider && /*#__PURE__*/ jsx(Divider, {})
            ]
        });
        $[5] = config.plugins.selectAllPlugin.value;
        $[6] = config.plugins.selectAllPlugin.withDivider;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== config.plugins.formatHeadingPlugin) {
        t4 = config.plugins.formatHeadingPlugin && /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx(FormatHeadingPlugin, _object_spread({}, config.plugins.formatHeadingPlugin)),
                config.plugins.formatHeadingPlugin.withDivider && /*#__PURE__*/ jsx(Divider, {})
            ]
        });
        $[8] = config.plugins.formatHeadingPlugin;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== config.plugins.formatTextPlugin) {
        t5 = config.plugins.formatTextPlugin && /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx(FormatTextPlugin, _object_spread({}, config.plugins.formatTextPlugin)),
                config.plugins.formatTextPlugin.withDivider && /*#__PURE__*/ jsx(Divider, {})
            ]
        });
        $[10] = config.plugins.formatTextPlugin;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== config.plugins.listAndFormatPlugin) {
        t6 = config.plugins.listAndFormatPlugin && /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx(ListAndFormatPlugin, _object_spread({}, config.plugins.listAndFormatPlugin)),
                config.plugins.listAndFormatPlugin.withDivider && /*#__PURE__*/ jsx(Divider, {})
            ]
        });
        $[12] = config.plugins.listAndFormatPlugin;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== config.plugins.linkAndTablePlugin || $[15] !== floatingAnchorElem) {
        t7 = config.plugins.linkAndTablePlugin && /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx(LinkAndTablePlugin, _object_spread({}, config.plugins.linkAndTablePlugin)),
                floatingAnchorElem && /*#__PURE__*/ jsx(TableActionMenuPlugin, {
                    anchorElem: floatingAnchorElem
                }),
                config.plugins.linkAndTablePlugin.withDivider && /*#__PURE__*/ jsx(Divider, {})
            ]
        });
        $[14] = config.plugins.linkAndTablePlugin;
        $[15] = floatingAnchorElem;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== config.mode || $[18] !== config.plugins.mediaPlugin || $[19] !== loadFile || $[20] !== onUploadError) {
        t8 = config.plugins.mediaPlugin && /*#__PURE__*/ jsx(MediaPlugin, _object_spread({
            loadFile: loadFile,
            onUploadError: onUploadError,
            mode: config.mode
        }, config.plugins.mediaPlugin));
        $[17] = config.mode;
        $[18] = config.plugins.mediaPlugin;
        $[19] = loadFile;
        $[20] = onUploadError;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8) {
        t9 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            children: [
                t3,
                t4,
                t5,
                t6,
                t7,
                t8
            ]
        });
        $[22] = t3;
        $[23] = t4;
        $[24] = t5;
        $[25] = t6;
        $[26] = t7;
        $[27] = t8;
        $[28] = t9;
    } else t9 = $[28];
    let t10;
    if ($[29] !== config.plugins.undoRedoPlugin) {
        t10 = config.plugins.undoRedoPlugin && /*#__PURE__*/ jsx(UndoRedoPlugin, {});
        $[29] = config.plugins.undoRedoPlugin;
        $[30] = t10;
    } else t10 = $[30];
    let t11;
    if ($[31] !== t10) {
        t11 = /*#__PURE__*/ jsx(Box, {
            children: t10
        });
        $[31] = t10;
        $[32] = t11;
    } else t11 = $[32];
    let t12;
    if ($[33] !== bgcolor || $[34] !== t11 || $[35] !== t2 || $[36] !== t9) {
        t12 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            bgcolor: bgcolor,
            className: t2,
            pb: "16",
            children: [
                t9,
                t11
            ]
        });
        $[33] = bgcolor;
        $[34] = t11;
        $[35] = t2;
        $[36] = t9;
        $[37] = t12;
    } else t12 = $[37];
    return t12;
};
export { ToolbarPlugins };
